import { render, staticRenderFns } from "./AcquisitionParameter.vue?vue&type=template&id=63d521f7&scoped=true&"
import script from "./AcquisitionParameter.vue?vue&type=script&lang=js&"
export * from "./AcquisitionParameter.vue?vue&type=script&lang=js&"
import style0 from "./AcquisitionParameter.vue?vue&type=style&index=0&id=63d521f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d521f7",
  null
  
)

export default component.exports